module.exports = __webpack_public_path__ + "img/icon-auth-facebook.ef55500e.svg";